import { render } from "./detail-internal-comments.vue?vue&type=template&id=bc29db8c&scoped=true&ts=true"
import script from "./detail-internal-comments.vue?vue&type=script&lang=ts"
export * from "./detail-internal-comments.vue?vue&type=script&lang=ts"

import "./detail-internal-comments.vue?vue&type=style&index=0&id=bc29db8c&scoped=true&lang=css"

import exportComponent from "C:\\agent\\_work\\44\\s\\DesignReg.VueClient\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc29db8c"]])

export default __exports__